import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const wards23 = [
  '千代田区', '中央区', '港区', '新宿区', '文京区',
  '台東区', '墨田区', '江東区', '品川区', '目黒区',
  '大田区', '世田谷区', '渋谷区', '中野区', '杉並区',
  '豊島区', '北区', '荒川区', '板橋区', '練馬区',
  '足立区', '葛飾区', '江戸川区',
];

const adjacentCities = [
  '三鷹市', '武蔵野市', '調布市', '狛江市',
  '府中市', '国分寺市', '小金井市', '西東京市',
  '川崎市（一部）', '横浜市（一部）',
];

export default function ServiceArea() {
  const { ref, isVisible } = useScrollAnimation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="area" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div ref={ref} className={`fade-in-up ${isVisible ? 'visible' : ''}`}>

          <div className="text-center mb-14">
            <span className="text-[#38BDF8] text-sm font-medium tracking-widest">SERVICE AREA</span>
            <h2 className="text-[#0D1A4E] text-3xl md:text-4xl font-black mt-3 mb-4">対応エリア</h2>
            <div className="w-12 h-1 bg-[#38BDF8] mx-auto"></div>
            <p className="text-gray-500 mt-6 text-sm leading-relaxed">
              東京23区を中心に活動しています。隣接する市部もご相談ください。
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 items-start">

            {/* 左：エリア情報 */}
            <div className="space-y-6">

              {/* メインエリア */}
              <div className="bg-[#0D1A4E] rounded-lg p-7">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#38BDF8]/20 rounded-md">
                    <i className="ri-map-pin-2-fill text-[#38BDF8] text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/60 text-xs">メイン対応エリア</p>
                    <p className="text-white font-black text-lg leading-none mt-0.5">東京23区（全域）</p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {wards23.map((ward) => (
                    <span
                      key={ward}
                      className="bg-white/10 text-white/85 text-xs px-3 py-1.5 rounded-full border border-white/15 font-medium"
                    >
                      {ward}
                    </span>
                  ))}
                </div>
              </div>

              {/* 隣接エリア */}
              <div className="border border-[#38BDF8]/30 bg-[#38BDF8]/5 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#38BDF8]/15 rounded-md">
                    <i className="ri-map-pin-line text-[#38BDF8] text-base"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs">隣接エリア（ご相談ください）</p>
                    <p className="text-[#0D1A4E] font-bold text-sm leading-none mt-0.5">23区に隣接する市部など</p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {adjacentCities.map((city) => (
                    <span
                      key={city}
                      className="bg-white border border-[#38BDF8]/40 text-[#0D1A4E] text-xs px-3 py-1.5 rounded-full font-medium"
                    >
                      {city}
                    </span>
                  ))}
                </div>
              </div>

              {/* エリア外相談 */}
              <div className="border border-gray-100 rounded-lg p-6 flex items-start gap-4 bg-gray-50/50">
                <div className="w-9 h-9 flex items-center justify-center bg-[#38BDF8]/10 rounded-md flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line text-[#38BDF8] text-base"></i>
                </div>
                <div>
                  <p className="text-[#0D1A4E] font-bold text-sm mb-1">上記エリア外も、まずご相談を</p>
                  <p className="text-gray-500 text-xs leading-relaxed">
                    記載以外のエリアでもご相談いただければ柔軟に検討します。
                    まずはお電話またはフォームにてお問い合わせください。
                  </p>
                  <button
                    onClick={() => scrollTo('contact')}
                    className="mt-3 text-[#38BDF8] text-xs font-bold hover:underline cursor-pointer whitespace-nowrap"
                  >
                    見積りを依頼する <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>

            </div>

            {/* 右：地図 */}
            <div className="rounded-lg overflow-hidden border border-gray-100 h-full min-h-[480px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d103005.94816657717!2d139.60730849999998!3d35.6894875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x605d1b87f02e57e7%3A0x2e01618b22571b89!2z5p2x5Lqs5Yy6!5e0!3m2!1sja!2sjp!4v1710000000000!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ minHeight: '480px', border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="対応エリアマップ（東京都）"
              ></iframe>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
